import { Currency } from '@pancakeswap/sdk'
import { Fragment, memo } from 'react'
import { unwrappedToken } from '@/utils/wrappedCurrency'
import { Typography } from '@/components/ui/typography'
import { ChevronRightIcon } from '@radix-ui/react-icons'

export default memo(function SwapRoute({ path }: { path: Currency[] }) {
  return (
    <div className={'flex text-sm flex-wrap w-full justify-end items-center'}>
      {path.map((token, i) => {
        const isLastItem: boolean = i === path.length - 1
        const currency = token.isToken ? unwrappedToken(token) : token
        return (
          // There might be same token appear more than once
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`${currency?.symbol}_${i}`}>
            <div className={'flex items-end'}>
              <Typography>{currency?.symbol}</Typography>
            </div>
            {!isLastItem && <ChevronRightIcon width="12px" />}
          </Fragment>
        )
      })}
    </div>
  )
})
